import { render } from "./ReturnRequestStep1.vue?vue&type=template&id=51d5565e&ts=true"
import script from "./ReturnRequestStep1.vue?vue&type=script&lang=ts"
export * from "./ReturnRequestStep1.vue?vue&type=script&lang=ts"

import exportComponent from "/vercel/path0/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__